export class AdminDashboard{
    public TotalSellers: string = "";
    public TotalListing: string = "";
    public ActiveListing: string = "";
    public InactiveListing: string = "";
    public TotalEnquiries: string = "";
    public ResolvedEnquiries: string = "";
    public PendingEnquiries: string = "";
}